var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7524 10.0545C20.8148 9.88631 20.8168 9.70229 20.7582 9.53286C20.6996 9.36342 20.5838 9.21872 20.43 9.1227C20.2763 9.02667 20.0937 8.98507 19.9126 9.00478C19.7315 9.02449 19.5627 9.10433 19.4341 9.23109L13.0342 15.5163C12.9622 15.5872 12.9046 15.6709 12.8646 15.763L8.06471 26.7622C8.01253 26.8817 7.99138 27.0121 8.00318 27.1417C8.01498 27.2713 8.05934 27.3959 8.1323 27.5045C8.20526 27.613 8.30452 27.7021 8.42118 27.7637C8.53784 27.8253 8.66825 27.8575 8.8007 27.8574H13.6006C13.765 27.8573 13.9254 27.8075 14.06 27.7147C14.1945 27.6219 14.2967 27.4907 14.3526 27.3388L20.7524 10.0545ZM23.9284 12.6047C23.8637 12.4643 23.7584 12.3456 23.6255 12.2636C23.4927 12.1815 23.3382 12.1396 23.1813 12.1431C23.0244 12.1466 22.872 12.1954 22.7431 12.2833C22.6142 12.3713 22.5145 12.4945 22.4564 12.6377L19.2565 20.4942C19.2056 20.6196 19.1884 20.7557 19.2066 20.8894C19.2248 21.0232 19.2778 21.1501 19.3605 21.2579L23.4948 26.671L14.9478 29.468C14.7668 29.5264 14.613 29.6463 14.514 29.8062C14.415 29.966 14.3774 30.1553 14.4079 30.34C14.4383 30.5247 14.5349 30.6926 14.6802 30.8136C14.8256 30.9346 15.0101 31.0007 15.2006 31H31.2002C31.3341 31 31.4658 30.9669 31.5833 30.904C31.7008 30.841 31.8003 30.7501 31.8727 30.6395C31.9452 30.529 31.9882 30.4024 31.9979 30.2712C32.0076 30.1401 31.9836 30.0087 31.9282 29.8891L23.9284 12.6047Z",
    fill: "#151521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.c5a586dc07a538d6eda73f831afdc5ad.svg";
export { ForwardRef as ReactComponent };